import * as React from 'react'
import { OwnerProvider } from './Provider'
import { type IFilterMode, MultiSelectFilter } from '@user/components/Filters'
import { useFormikContext } from 'formik'
import { ActivitySummaryFilterSet } from '@user/features/Activity/ActivitySummary/typings'

export function OwnerFilter(props: IFilterMode) {
  const {
    values: {
      filters: {
        salesTeamIds: {
          value: { options },
        },
      },
    },
  } = useFormikContext<ActivitySummaryFilterSet>()

  return (
    <MultiSelectFilter
      {...props}
      label="Owner"
      name="ownerId"
      hideModeSelect
      dependsOn={options}
      component={OwnerProvider}
    />
  )
}
